import { HttpHandler } from 'msw'

import { getAllSites } from './getAllSites'

export const sites: HttpHandler[] = [getAllSites]
